import { render, staticRenderFns } from "./sharemanage.vue?vue&type=template&id=0dfb4263&scoped=true&"
import script from "./sharemanage.vue?vue&type=script&lang=js&"
export * from "./sharemanage.vue?vue&type=script&lang=js&"
import style0 from "./sharemanage.vue?vue&type=style&index=0&id=0dfb4263&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dfb4263",
  null
  
)

export default component.exports